import {
    LoadMoreAction,
    RECEIVED_POSTS_SUCCESSFULLY,
    RECEIVED_POSTS_UNSUCCESSFULLY,
    REQUEST_POSTS,
} from '../loadMore.actions';
import { SECTION_NAMES } from '../../../templates/templates.const';
import { SearchPageExpandableSection } from '../template.state.types';

interface SearchPageWithTopSection {
    [SECTION_NAMES.TOP_SECTION]: SearchPageExpandableSection;
}

export const searchPageReducer = <T extends SearchPageWithTopSection>(state: T = {} as T, action: LoadMoreAction<keyof SearchPageWithTopSection>) => {
    switch (action.type) {
        case RECEIVED_POSTS_SUCCESSFULLY: {
            const oldArticles = state[action.sectionKey].articles || [];
            return {
                ...state,
                [action.sectionKey]: {
                    ...state[action.sectionKey],
                    articles: [
                        ...oldArticles,
                        ...action.articles,
                    ],
                    seeMorePaginationURL: action.next,
                },
            };
        }
        case RECEIVED_POSTS_UNSUCCESSFULLY: {
            return state;
        }

        case REQUEST_POSTS: {
            return state;
        }
        default:
            return state;
    }
};
